/*
 * Auralith | Free Eleva — Fabish theme integration
 * The existing Shopify automatic Buy X Get Y discount supplies the price reduction.
 * This script only selects/adds/removes the complimentary item in the storefront cart.
 */
(() => {
  'use strict';

  const configNode = document.getElementById('auralith-free-elava-config');
  const modal = document.getElementById('auralith-free-elava-modal');
  if (!configNode || !modal) return;

  let config;
  try { config = JSON.parse(configNode.textContent); } catch (error) { console.error('[Auralith Gift] Invalid product configuration', error); return; }
  if (!config.productId || !Array.isArray(config.variants) || !config.variants.some((v) => v.available)) return;

  const giftFlag = '_auralith_free_elava';
  const dismissKey = 'auralith-free-elava-dismissed-v1';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  const dialog = modal.querySelector('.auralith-gift-modal__dialog');
  const submit = document.getElementById('auralith-gift-add');
  const errorNode = document.getElementById('auralith-gift-error');
  const variantInputs = [...modal.querySelectorAll('input[name="auralith-elava-colour"]')];
  let lastCart = null;
  let busy = false;
  let rerun = false;
  let syncTimer;
  let autoOpenTimer;
  let previousFocus = null;
  let drawerWasOpen = false;
  let discountUnavailable = false;

  function getDismissed() {
    try { return sessionStorage.getItem(dismissKey) === '1'; } catch (_) { return false; }
  }
  function setDismissed(value) {
    try { if (value) sessionStorage.setItem(dismissKey, '1'); else sessionStorage.removeItem(dismissKey); } catch (_) { /* storage may be blocked */ }
  }
  function giftLines(cart) {
    return (cart.items || []).filter((item) =>
      Number(item.product_id) === Number(config.productId) &&
      item.properties && String(item.properties[giftFlag]) === '1'
    );
  }
  function qualifyingSubtotal(cart) {
    // Exclude ONLY the gift this script added. Paid Eleva purchases remain eligible.
    return (cart.items || []).reduce((total, item) => {
      if (Number(item.product_id) === Number(config.productId) && item.properties && String(item.properties[giftFlag]) === '1') return total;
      return total + Number(item.original_line_price || 0);
    }, 0);
  }
  function isEligible(cart) { return qualifyingSubtotal(cart) >= Number(config.threshold); }
  function selectedVariant() {
    const selected = variantInputs.find((input) => input.checked && !input.disabled);
    return selected ? Number(selected.value) : null;
  }
  function showError(message) { errorNode.textContent = message; errorNode.hidden = false; }
  function clearError() { errorNode.textContent = ''; errorNode.hidden = true; }
  function cartEndpoint(action) { return `${root}cart/${action}.js`; }
  async function getCart() {
    const response = await nativeFetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Could not read your cart. Please refresh the page.');
    return response.json();
  }
  async function cartWrite(action, payload) {
    const response = await nativeFetch(cartEndpoint(action), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    let result = {};
    try { result = await response.json(); } catch (_) { /* Shopify may return a non-JSON error */ }
    if (!response.ok) throw new Error(result.description || result.message || 'The cart could not be updated. Please try again.');
    return result;
  }
  async function removeLine(line) {
    await cartWrite('change', { id: line.key, quantity: 0 });
  }
  async function setLineQuantity(line, quantity) {
    await cartWrite('change', { id: line.key, quantity });
  }
  function formatRupees(paise) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 2
    }).format(Number(paise || 0) / 100);
  }
  function updateUnlock(cart) {
    const subtotal = qualifyingSubtotal(cart);
    const threshold = Number(config.threshold);
    const remaining = Math.max(0, threshold - subtotal);
    document.querySelectorAll('[data-auralith-gift-unlock]').forEach((panel) => {
      panel.hidden = remaining <= 0 || !cart.item_count;
      if (panel.hidden) return;
      const remainingNode = panel.querySelector('[data-auralith-gift-remaining]');
      const currentNode = panel.querySelector('[data-auralith-gift-current]');
      const fill = panel.querySelector('[data-auralith-gift-fill]');
      const progress = panel.querySelector('[data-auralith-gift-progress]');
      if (remainingNode) remainingNode.textContent = formatRupees(remaining);
      if (currentNode) currentNode.textContent = formatRupees(subtotal);
      if (fill) fill.style.width = `${Math.min(100, Math.max(0, subtotal / threshold * 100))}%`;
      if (progress) progress.setAttribute('aria-valuenow', String(Math.min(5000, Math.floor(subtotal / 100))));
    });
  }
  function setBanner(cart) {
    updateUnlock(cart);
    const eligible = isEligible(cart);
    const gift = giftLines(cart)[0];
    document.querySelectorAll('[data-auralith-gift-banner]').forEach((banner) => {
      banner.hidden = !eligible;
      if (!eligible) return;
      const title = banner.querySelector('[data-auralith-gift-banner-title]');
      const description = banner.querySelector('[data-auralith-gift-banner-description]');
      const button = banner.querySelector('[data-auralith-open-gift]');
      if (gift) {
        const variant = config.variants.find((v) => Number(v.id) === Number(gift.variant_id));
        title.textContent = 'Your complimentary Eleva is in the cart';
        description.textContent = `Selected colour: ${variant ? variant.title : 'Eleva'}`;
        button.textContent = 'Change colour';
      } else {
        title.textContent = discountUnavailable ? 'Free gift is temporarily unavailable' : 'You have unlocked a FREE Eleva!';
        description.textContent = discountUnavailable ? 'The automatic gift discount did not apply. Please contact us.' : 'Choose your complimentary Beige or Silver sculpture.';
        button.textContent = 'Choose colour';
        button.disabled = discountUnavailable;
      }
      if (gift) button.disabled = false;
    });
  }
  function updateCartIcon(html) {
    if (!html) return;
    const current = document.getElementById('cart-icon-bubble');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const section = parsed.querySelector('.shopify-section');
    if (current && section) current.innerHTML = section.innerHTML;
  }
  async function refreshCartUI(openDrawer = false) {
    // Shopify section rendering keeps Fabish's native drawer and cart count in sync.
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    const response = await nativeFetch(`${root}cart?sections=cart-drawer,cart-icon-bubble`, {
      credentials: 'same-origin', cache: 'no-store'
    });
    if (!response.ok) throw new Error('Could not refresh the cart display.');
    const sections = await response.json();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      if (openDrawer && typeof drawer.renderContents === 'function' && sections['cart-icon-bubble']) {
        drawer.renderContents({ id: config.productId, sections });
      } else {
        const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newDrawer = parsed.querySelector('#CartDrawer');
        const currentDrawer = drawer.querySelector('#CartDrawer');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          const overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', () => drawer.close());
        }
      }
      if (lastCart) drawer.classList.toggle('is-empty', lastCart.item_count === 0);
    }
    updateCartIcon(sections['cart-icon-bubble']);
    if (lastCart) setBanner(lastCart);
  }
  function openPopup() {
    if (busy || !lastCart || !isEligible(lastCart) || modal.hidden === false) return;
    clearError();
    const existingGift = giftLines(lastCart)[0];
    const currentVariantId = existingGift && Number(existingGift.variant_id);
    const chosen = variantInputs.find((input) => Number(input.value) === currentVariantId && !input.disabled)
      || variantInputs.find((input) => !input.disabled);
    variantInputs.forEach((input) => { input.checked = input === chosen; });
    if (!chosen) return;
    previousFocus = document.activeElement;
    const drawer = document.querySelector('cart-drawer');
    drawerWasOpen = Boolean(drawer && drawer.classList.contains('active'));
    if (drawerWasOpen && typeof drawer.close === 'function') drawer.close();
    submit.textContent = existingGift ? 'UPDATE MY FREE GIFT' : 'ADD MY FREE GIFT';
    modal.hidden = false;
    document.body.classList.add('auralith-gift-modal-open');
    dialog.focus();
  }
  function closePopup(dismiss = true, restoreDrawer = true) {
    if (modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('auralith-gift-modal-open');
    if (dismiss) setDismissed(true);
    if (restoreDrawer && drawerWasOpen) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    }
    drawerWasOpen = false;
    if (previousFocus && typeof previousFocus.focus === 'function' && document.contains(previousFocus)) previousFocus.focus();
    previousFocus = null;
  }
  async function reconcile() {
    if (busy) { rerun = true; return; }
    busy = true;
    try {
      let cart = await getCart();
      let gifts = giftLines(cart);
      if (!isEligible(cart)) {
        setDismissed(false);
        discountUnavailable = false;
        if (!modal.hidden) closePopup(false, false);
        if (gifts.length) {
          for (const gift of gifts) await removeLine(gift);
          cart = await getCart();
          lastCart = cart;
          await refreshCartUI(false);
        }
      } else if (gifts.length) {
        // Never leave more than one promotional gift in the cart.
        let cleanedUp = gifts.length > 1;
        for (const extra of gifts.slice(1)) await removeLine(extra);
        if (gifts.length > 1) cart = await getCart();
        gifts = giftLines(cart);
        if (gifts[0] && gifts[0].quantity > 1) {
          cleanedUp = true;
          await setLineQuantity(gifts[0], 1);
          cart = await getCart();
          gifts = giftLines(cart);
        }
        // Safety: a complimentary gift must not remain as a charged product.
        if (gifts[0] && Number(gifts[0].final_line_price) > 0) {
          for (const gift of gifts) await removeLine(gift);
          discountUnavailable = true;
          setDismissed(true);
          cart = await getCart();
          lastCart = cart;
          await refreshCartUI(false);
        } else if (gifts[0]) {
          discountUnavailable = false;
          setDismissed(true);
          if (cleanedUp) { lastCart = cart; await refreshCartUI(false); }
        }
      }
      lastCart = cart;
      setBanner(cart);
      if (isEligible(cart) && !giftLines(cart).length && !getDismissed() && !discountUnavailable && modal.hidden) {
        clearTimeout(autoOpenTimer);
        autoOpenTimer = setTimeout(() => { if (!busy) openPopup(); }, 260);
      }
    } catch (error) {
      console.error('[Auralith Gift] Could not sync gift', error);
    } finally {
      busy = false;
      if (rerun) { rerun = false; scheduleSync(150); }
    }
  }
  function scheduleSync(delay = 260) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(reconcile, delay);
  }
  async function chooseGift() {
    if (busy || !lastCart) return;
    const variantId = selectedVariant();
    if (!variantId) { showError('Please select a colour.'); return; }
    const variant = config.variants.find((v) => Number(v.id) === variantId);
    if (!variant || !variant.available) { showError('This colour is currently unavailable. Please choose another.'); return; }
    busy = true;
    submit.disabled = true;
    submit.textContent = 'ADDING YOUR GIFT...';
    clearError();
    try {
      let cart = await getCart();
      if (!isEligible(cart)) {
        lastCart = cart;
        closePopup(false, false);
        setBanner(cart);
        throw new Error('Your cart is below ₹5,000. Add more products to unlock Eleva.');
      }
      const existing = giftLines(cart);
      if (existing.length === 1 && Number(existing[0].variant_id) === variantId && existing[0].quantity === 1 && Number(existing[0].final_line_price) === 0) {
        setDismissed(true);
        closePopup(false, false);
        await refreshCartUI(true);
        return;
      }
      // Add the new selection first, so a failed add does not discard the old gift.
      if (!existing.some((item) => Number(item.variant_id) === variantId)) {
        await cartWrite('add', { items: [{ id: variantId, quantity: 1, properties: { [giftFlag]: '1' } }] });
      }
      cart = await getCart();
      for (const old of giftLines(cart)) {
        if (Number(old.variant_id) !== variantId) await removeLine(old);
      }
      cart = await getCart();
      let selected = giftLines(cart).find((item) => Number(item.variant_id) === variantId);
      if (selected && selected.quantity > 1) {
        await setLineQuantity(selected, 1);
        cart = await getCart();
        selected = giftLines(cart).find((item) => Number(item.variant_id) === variantId);
      }
      if (!selected) throw new Error('The selected Eleva could not be added. Please try again.');
      if (Number(selected.final_line_price) !== 0) {
        // Protect customers: do not leave a full-price promotional gift in the cart.
        await removeLine(selected);
        cart = await getCart();
        lastCart = cart;
        discountUnavailable = true;
        setDismissed(true);
        await refreshCartUI(false);
        throw new Error('Shopify did not apply the free Eleva discount. The gift was removed so you will not be charged. Please contact the store.');
      }
      discountUnavailable = false;
      setDismissed(true);
      lastCart = cart;
      closePopup(false, false);
      await refreshCartUI(true);
    } catch (error) {
      showError(error.message || 'Could not add your free gift. Please try again.');
      console.error('[Auralith Gift] Add failed', error);
    } finally {
      busy = false;
      submit.disabled = false;
      submit.textContent = 'ADD MY FREE GIFT';
      if (lastCart) setBanner(lastCart);
      if (rerun) { rerun = false; scheduleSync(150); }
    }
  }

  // Fabish uses fetch for add-to-cart and quantity changes. Watch successful
  // cart writes without altering the theme's existing handlers or their responses.
  function isCartWrite(url, method) {
    if (String(method || 'GET').toUpperCase() === 'GET') return false;
    const path = String(url || '').split('?')[0];
    return /\/cart\/(add|change|update|clear)(?:\.js)?\/?$/.test(path);
  }
  window.fetch = function (...args) {
    const request = args[0];
    const url = typeof request === 'string' ? request : request && request.url;
    const method = args[1] && args[1].method || (request && request.method) || 'GET';
    const responsePromise = nativeFetch(...args);
    if (!isCartWrite(url, method)) return responsePromise;
    return responsePromise.then((response) => {
      if (response.ok) scheduleSync(360);
      return response;
    });
  };
  if (window.jQuery) {
    window.jQuery(document).ajaxComplete((_event, xhr, options) => {
      if (xhr.status >= 200 && xhr.status < 300 && isCartWrite(options.url, options.type)) scheduleSync(360);
    });
  }

  // The recommendations are rendered by Liquid and updated with Fabish's cart drawer.
  // Use delegated events so the buttons keep working after the drawer re-renders.
  async function addRecommendedProduct(button) {
    if (busy || button.disabled) return;
    const variantId = Number(button.getAttribute('data-auralith-recommend-add'));
    if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
    const panel = button.closest('[data-auralith-gift-unlock]');
    const error = panel && panel.querySelector('[data-auralith-recommend-error]');
    const originalText = button.textContent;
    busy = true;
    button.disabled = true;
    button.textContent = 'Adding...';
    if (error) { error.hidden = true; error.textContent = ''; }
    try {
      await cartWrite('add', { items: [{ id: variantId, quantity: 1 }] });
      lastCart = await getCart();
      await refreshCartUI(true);
    } catch (problem) {
      if (error) {
        error.textContent = problem.message || 'Could not add this product. Please try again.';
        error.hidden = false;
      }
      console.error('[Auralith Gift] Recommendation add failed', problem);
    } finally {
      busy = false;
      if (document.contains(button)) { button.disabled = false; button.textContent = originalText; }
      scheduleSync(160);
    }
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-auralith-recommend-add]');
    if (!button) return;
    event.preventDefault();
    addRecommendedProduct(button);
  });

  submit.addEventListener('click', chooseGift);
  modal.querySelectorAll('[data-auralith-gift-close]').forEach((button) => {
    button.addEventListener('click', () => closePopup(true, true));
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-auralith-open-gift]')) {
      event.preventDefault();
      if (lastCart && isEligible(lastCart) && !discountUnavailable) openPopup();
    }
  });
  modal.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { event.preventDefault(); closePopup(true, true); return; }
    if (event.key !== 'Tab') return;
    const focusables = [...dialog.querySelectorAll('button:not(:disabled), input:not(:disabled)')]
      .filter((el) => el.offsetParent !== null);
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) scheduleSync(150); });
  window.addEventListener('pageshow', (event) => { if (event.persisted) scheduleSync(150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scheduleSync(400), { once: true });
  else scheduleSync(400);

  // Exposed for QA in the browser console; no store mutations are triggered by reading it.
  window.AuralithFreeElava = {
    getStatus: () => ({
      configured: true,
      productId: config.productId,
      thresholdRupees: Number(config.threshold) / 100,
      eligibleSubtotalRupees: lastCart ? qualifyingSubtotal(lastCart) / 100 : null,
      eligible: lastCart ? isEligible(lastCart) : null,
      giftInCart: lastCart ? giftLines(lastCart).length > 0 : null,
      giftDiscountUnavailable: discountUnavailable
    }),
    refresh: () => scheduleSync(0)
  };
})();
